import React from 'react';

import { useGetRecords } from 'root/admin/components/hooks';
import { CreateNew } from 'root/admin/components';

import { Table, Column, Loader, Image } from '@smartplatform/ui';

const ArticleList = ({ rootPath, tabName }) => {
	const records = useGetRecords({ model: 'Bill', tabName });

	if (!records) {
		return <Loader />;
	}
	return (
		<div>
			<CreateNew link={`${rootPath}/bills/new`} name="Новый Закон" />
			<Table records={records} rootPath={rootPath}>
				<Column property="name" label="Название" />
			</Table>
		</div>
	);
};

export default ArticleList;
